import { createMap, createAddressLoookup, createPlaces} from './maps';
import { showLoader, hideLoader } from './loadIndicator';
import Drug from './drugs';
import Pharmacy from './pharmacy';
import State from './state';
import * as Carousel from './carousel';
import * as Config from './config';
import * as Icons from './icons';
import * as Modal from './Modal';
import * as Utils from './utils';
import { tracker as Analytics } from './analytics.js';

/**
 * Initializes the application
 */
export function start() {
    // options for intiializing the Google Maps service
    let mapOptions = {
        zoom: Config.DEFAULT_ZOOM,
        center: Config.DEFAULT_LOCATION,
        mapTypeControl: Config.MAP_TYPE_CONTROL
    };

    // options for initializing the Google Maps Autocomplete service
    let addressLookupOptions = {
        types: ['establishment', 'geocode'],
        componentRestrictions: { country: 'ca' }
    };

    // Gets drug list from the server
    fetchDrugList();

    // Starts all the Google Maps services and adds the listeners
    google.maps.event.addDomListener(window, 'load', () => {
        State.map = createMap(mapOptions);
        getUserPosition();
        State.placesService = createPlaces(State.map);
        State.addressLookup = createAddressLoookup(State.map, addressLookupOptions, 'location-search');

        State.addressLookup.addListener('place_changed', searchForLocation);
        selectFirstOnEnter(document.getElementById('location-search'));

        $(document).on("centerMap", (event, position) => {
            State.map.setCenter(position);
            if (State.selectedDrug) {
                getPharmaciesForDrugAndPosition(State.selectedDrug, position);
            }
        });
    });

    // Terms and Conditions link
    //$('#toc').on('click', ()=> {
    //    window.open(`${BASE_URL}/tac`);
    //});

    // Frequently Asked Questions link
    //$('#faq').on('click', () => {
    //    window.open(`${Config.FAQ_LINK}`);
    //});

    $('#pbc-logo').parent().attr('href', Config.PBC_LOGO_LINK);
    $('#pc-logo').parent().on('click', () => {
        location.reload();
    });

    // Carousel buttons
    $('.carousel-right').on('click', Carousel.moveCarousel.bind(null, '#cards', true));
    $('.carousel-left').on('click', Carousel.moveCarousel.bind(null, '#cards', false));

    // Clear drug search
    $('#drug-search').next('.clear-input').on('click', () => {
        clearDrugSearch();
    });

    // Clear location search
    $('#location-search').next('.clear-input').on('click', () => {
        $('#location-search').val('');
        State.position = {};
        searchForLocation();
    });

    // Selecting drug from drug list
    $('#autocomplete-results-list').on('mousedown', 'li', event => {
        let selection = $(event.currentTarget);
        selectDrug(selection);
    });

    // Adds keyboard actions to the drug search input
    $('#drug-search').on('keydown', ev => {
        let keyPressed = ev.keyCode;
        let $autocompleteResultsItems = $('#autocomplete-results-list').find('li');
        // Escape (Esc) key action
        if (keyPressed === 27) {
            clearDrugSearch();
        }
        // Enter (Enter) key action for all enter presses
        if (keyPressed === 13) {
            $('#drug-search').blur();
        }
        // If the list is empty, there is nothing to cycle through, so ignore this
        if (_.isEmpty($autocompleteResultsItems)) {
            return;
        } else {
            cycleThroughListItems($autocompleteResultsItems, keyPressed);
        }
    });

    // Hides the autocomplete list when other elements are clicked on
    $('#drug-search').on('blur', () => {
        $('#autocomplete-results-list').hide();
    });

    /* 
    Shows the autocomplete list when the drug search is focused but will show
    nothing if there are no current results from the search function
    */
    $('#drug-search').on('focus', () => {
        $('#autocomplete-results-list').show();
    })

    // Display version number, will only be populated in Dev/QA
    if (typeof APP_VERSION !== 'undefined') {
        $('#version').text(`V. ${APP_VERSION} `);
    }

    // Listens for location changes to modify the placeholder for the location serach
    $(document).on('locationChange', () => {
        if (State.currentUserPosition) {
            $('#location-search').attr('placeholder', Utils.i18n('havePositionPlaceholder'));
        } else {
            $('#location-search').attr('placeholder', Utils.i18n('noPositionPlaceholder'));
        }
    });

    addLegendPopovers();

    addWhatIsPharmacyCompassPopover();

    // Launches the analytics suite
    window.addEventListener('load', () => {
        Analytics.launch();
    });
}

function addLegendPopovers() {
    let $legendPreferred = $('#legend').find('.preferred-provider');
    let $popoverPreferredTarget = $legendPreferred.children().first();

    let $legendSpecialAuthority = $('#legend').find('.special-authority-provider');
    let $popoverSpecialAuthorityTarget = $legendSpecialAuthority.children().first();

    $popoverPreferredTarget.popover({
        container: '.body-content',
        content: `
            <div class="po-content" id="pp-legend-popup">
                <div class="po-title">${Utils.i18n('preferredProvider')}</div>
                ${Utils.i18n('preferredProviderDetails')}
                <a class="po-link" href="${Config.PREFERRED_FAQ_LINK}" target="_blank">${Utils.i18n('readMore')}</a>
            </div>`,
        placement: 'top',
        html: true,
        trigger: 'manual',
        viewport: '#map-container'
    });

    $popoverSpecialAuthorityTarget.popover({
        container: '.body-content',
        content: `
            <div class="po-content" id="pp-legend-popup">
                <div class="po-title">${Utils.i18n('specialAuthority')}</div>
                ${Utils.i18n('specialAuthorityDetails')}
                <a class="po-link" href="${Config.SA_FAQ_LINK}" target="_blank">${Utils.i18n('readMore')}</a>
            </div>`,
        placement: 'top',
        html: true,
        trigger: 'manual',
        viewport: '#map-container'
    });

    $legendPreferred.on('focus', ev => {
        $popoverPreferredTarget.popover('show');
    });

    $legendPreferred.on('blur', ev => {
        $popoverPreferredTarget.popover('hide');
    });

    $legendSpecialAuthority.on('focus', ev => {
        $popoverSpecialAuthorityTarget.popover('show');
    });
   
    $legendSpecialAuthority.on('blur', ev => {
        $popoverSpecialAuthorityTarget.popover('hide');
    });

}

function addWhatIsPharmacyCompassPopover()
{
    let $whatispharm = $('#whatispharm');
    $whatispharm
        .popover({
            container: '.body-content',
            content: Utils.i18n('whatIsPharmacyCompassDetail', Config.FAQ_LINK),
            placement: 'bottom',
            html: true,
            trigger: 'manual',
            viewport: '#uibar1'
        })
        .on('focus', function () {
            $whatispharm.popover('show');
        })
        .on('blur', function () {
            $whatispharm.popover('hide');
        })
        .text(Utils.i18n('whatIsPharmacyCompass'));
}

/**
 * Clears the drug search input and autocomplete suggestions
 */
function clearDrugSearch() {
    State.selectedDrug = null;
    $('#drug-search').val('');
    clearSuggestions();
}

/**
 * Selects the drug by the jQuery selected dom element.
 * 
 * @param {jQuery object} selection - A jQuery object with data attribute 'id' that will be passed to setSelectedDrug
 */
function selectDrug(selection) {
    setSelectedDrug(State.drugs, selection.data('din'));
    $('#drug-search').val(selection.text());
    $('#drug-search').blur();
    clearSuggestions();
}

/**
 * Cycles through any given array of items, cycling the selected class to them in order. Hitting enter will run
 * the callback on the item with the selected class.
 * 
 * @param {array} list - An array of dom elements
 * @param {number} key - a javascript keyCode
 */
function cycleThroughListItems(list, key) {
    let selectedItem = list.closest('.selected');
    // up arrow
    if (key === 38) {
        if (selectedItem) {
            selectedItem.removeClass('selected');
            // Cycle upwards through the list
            let nextItem = selectedItem.prev();
            if (nextItem.length > 0) {
                selectedItem = nextItem.addClass('selected');
            } 
            else {
                selectedItem = list.last().addClass('selected');
            }
        }
        // If there is no item selected, select the last item on the list
        else {
            selectedItem = list.last().addClass('selected');
        }
    }
    // down arrow
    else if (key === 40) {
        if (selectedItem) {
            selectedItem.removeClass('selected');
            // Cycle downwards through the list
            let nextItem = selectedItem.next();
            if (nextItem.length > 0) {
                selectedItem = nextItem.addClass('selected');
            } 
            else {
                selectedItem = list.first().addClass('selected');
            }
        } 
        // If there is no item selected, select the first item of the list
        else {
            selectedItem = list.first().addClass('selected');
        }
    }
    // enter
    else if (key === 13) {
        let selection = list.closest('.selected')
        if (_.isEmpty(selection)) {
            selection = list.first('li');
        }
        selectDrug(selection);
    }
}

/**
 * Searches for a location using Google Places service
 */
function searchForLocation() {
    // Forces exit from street view
    State.map.getStreetView().setVisible(false);
    let searchTerm = $('#location-search').val();
    if (searchTerm) {
        Analytics.sendEvent(null, Analytics.events.place, Analytics.actions.search, searchTerm);
        resetSearchLocation();
        try {
            State.position = State.addressLookup.getPlace().geometry.location.toJSON();
            State.searchLocationMarker = addMarkerToMap(State.position, Icons.getIcon('searchLocation'));
            let markers = getMarkers('searchLocationMarker');
            zoomToFitLocations(markers);
        } catch(err) {
            State.position = {};
        }
    } else {
        resetSearchLocation();
        State.position = {};
    }
    if (State.selectedDrug) {
        getPharmaciesForDrugAndPosition(State.selectedDrug, State.getLocationForSearch());
    } else {
        removePharmacies();
        $('#pharmacy-cards').removeClass('show-cards');
    }
}

/**
 * Takes an input and simulates a down, then enter key action on it when enter is hitting
 * 
 * @param {DOM element} input - An <input> element to attach the simulated keys on
 */
function selectFirstOnEnter(input) {      
    // store the original event binding function
    var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;
    function addEventListenerWrapper(type, listener) { 
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected, and then trigger the original listener.
        if (type == "keydown") { 
            var orig_listener = listener;
            listener = function (event) {
            var suggestion_selected = $(".pac-item-selected").length > 0;
                if (event.which == 13 && !suggestion_selected) { 
                    $('#location-search').blur();
                    var simulated_downarrow = $.Event("keydown", {keyCode:40, which:40}); orig_listener.apply(input, [simulated_downarrow]); 
                }
                orig_listener.apply(input, [event]);
            };
        }
    _addEventListener.apply(input, [type, listener]); // add the modified listener
  }
  if (input.addEventListener) { input.addEventListener = addEventListenerWrapper; } else if (input.attachEvent) { input.attachEvent = addEventListenerWrapper; }
}

/**
 * Resets the search location, and search location marker
 */
function resetSearchLocation() {
    if (State.searchLocationMarker) {
        State.searchLocationMarker.setMap(null);
        State.searchLocationMarker = null;
    }
}

/**
 * Gets the user's current location. Requires HTTPS:// connection to work.
 * 
 * @param {boolean} isPolling - Flag for whether or not this is being called by a periodic location poller
 */
function getUserPosition() {
    const loaderId = 'getUserPosition';
    let $pcInput = $('.pc-input input');
    let options = {
        enableHighAccuracy: true,
        timeout: 8000,
        maximumAge: 0
    }
    showLoader(loaderId);
    // navigator is browser native global
    if (navigator.geolocation) {
        // async
        var getLocation = new Promise((resolve, reject) => {
            /* 
            Firefox has an option to not give the user position, but also to not deny it. If the user selects "not now",
            no event will be fired. Because of this, we need to have a timeout that defaults to the default location if
            the user has not made a decision or has selected "not now".
            */
            var timeout = setTimeout(() => {
                reject('timeout');
            }, options.timeout);
            
            navigator.geolocation.getCurrentPosition(
                // Callback for successful location
                currentPosition => {
                    State.currentUserPosition = {
                        lat: currentPosition.coords.latitude,
                        lng: currentPosition.coords.longitude
                    };
                    clearTimeout(timeout);
                    resolve(State.currentUserPosition);
                },
                error => {
                    clearTimeout(timeout);
                    reject(error);
                },
                options
            );
        });

        getLocation
            .then(location => {
                State.currentLocationMarker = addMarkerToMap(State.currentUserPosition, Icons.getIcon('currentLocation'));
                Analytics.sendEvent(null, Analytics.events.location, Analytics.actions.allowed);
                $(document).trigger("centerMap", State.getLocationForSearch());
                $(document).trigger("locationChange");
                fetchLocalProviders(State.currentUserPosition);
                hideLoader(loaderId);
                $pcInput.removeAttr('disabled');
            })
            .catch(err => {
                State.currentLocationMarker = addMarkerToMap(State.DEFAULT_LOCATION, Icons.getIcon('currentLocation'));
                hideLoader(loaderId);
                $pcInput.removeAttr('disabled');
            });
    }
    // fallback for geolocation not being available 
    else {
        State.currentLocationMarker = addMarkerToMap(State.DEFAULT_LOCATION, Icons.getIcon('currentLocation'));
        hideLoader(loaderId);
        $pcInput.removeAttr('disabled');
    }
}

/**
 * Fetches the drug list from the API
 */
function fetchDrugList() {
    const loaderId = 'fetchDrugList';
    showLoader(loaderId);

    $.ajax({
        url: Config.endpoints.drugs
    })
    .done(data => {
        hideLoader(loaderId);
        State.drugFetchAttempts = 0;
        State.drugs = data.map(drug => new Drug(drug));
        $('#drug-search').on('input', ev => {
            displayAutoCompleteSuggestions(ev);
        });
    })
    .fail(err => {
        Analytics.sendEvent(null, Analytics.events.drug, Analytics.actions.error, Analytics.errors.failedToRetrieve);
        State.drugFetchAttempts++;
        if (State.drugFetchAttempts < Config.MAXIMUM_FETCH_ATTEMPTS) {
            console.warn(Utils.i18n('drugFetchFailure'));
            setTimeout(() => {
                fetchDrugList();
            }, 5000);
        } else {
            let errorModal = new Modal.ErrorModal();
            let modalContent = {
                header: Utils.i18n('drugFetchFailureFatalTitle'),
                body: Utils.i18n('drugFetchFailureFatalBody')
            }
            errorModal.openModal(modalContent, '#errorModal');
            console.error(Utils.i18n('drugFetchFailureFatalBody'));
        }
    });
}

/**
 * Fetches providers around the given location
 * 
 * @param {object} position - an object containing a lat and lng property
 * @returns {object} result - a json result
 */
function fetchLocalProviders(position) {
    let loaderId = 'fetchLocalProviders';
    showLoader(loaderId);

    $.ajax({
        url: Config.endpoints.pharmacies,
        data: {
            lat: position.lat,
            lng: position.lng
        }
    })
    .done(data => {
            State.pharmacies = data.map(pharmacy => new Pharmacy(pharmacy, null, State.placesService));
            showPharmacies(State.pharmacies);
            hideLoader(loaderId);
            return data;
        })
        .fail(err => {
            hideLoader(loaderId);
            console.warn(err)
        });
}

/**
 * Displays the autocomplete selection for a drug
 * 
 * @param {event} event - The event object for input to the drug search input
 */
function displayAutoCompleteSuggestions(event) {
    let searchValue = event.currentTarget.value;
    // returns here instead of searchDrugList to prevent iteration over the drug list
    if (searchValue === '') {
        clearSuggestions();
        return;
    }
    let suggestions = searchDrugList(event);
    let suggestionListItems = suggestions.map(suggestion => {
        return `<li data-din=${suggestion.din}>${suggestion.label}</li>`
    });
    $('#autocomplete-results-list').html(suggestionListItems);
}

/**
 * Searches the drug list from the API for the selected drug
 * 
 * @param {event} event - The event object for input to the drug search input
 */
function searchDrugList(event) {
    let filterValue = _.escapeRegExp($(event.currentTarget).val());
    let fuzzyFilter = new RegExp(`${filterValue}`, `i`);
    let startFilter = new RegExp(`^${filterValue}`, `i`);
    let matches = [];
    let fuzzyMatches = [];
    _.forEach(State.drugs, drug => {
        if (startFilter.test(drug.drugName) || startFilter.test(drug.din)) {
            matches.push(drug);
        } else if (fuzzyFilter.test(drug.drugName) || fuzzyFilter.test(drug.din)) {
            fuzzyMatches.push(drug);
        }
    });
    fuzzyMatches = _.sortBy(fuzzyMatches.slice(0, 10), drug => drug.drugName);
    matches.push(...fuzzyMatches);
    return matches.slice(0, 10);
}

/**
 * Clears the suggested results from the autocomplete results list
 */
function clearSuggestions() {
    $('#autocomplete-results-list').find('li').remove();
}

/**
 * Sets the selected drug to the state then gets providers for the selected drug close to the position
 * 
 * @param {json} drugs - the list of available drugs
 * @param {number/string} drugId - Id of the selected drug
 */
function setSelectedDrug(drugs, drugDin) {
    State.selectedDrug = _.find(drugs, drug => {
        return drug.din === drugDin;
    });
    getPharmaciesForDrugAndPosition(State.selectedDrug, State.getLocationForSearch());
    Analytics.sendEvent(null, Analytics.events.drug, Analytics.actions.search, State.selectedDrug.drugName);
}

/**
 * Gets providers for the selected drug around a given position. Position is determined by whether or not the user has
 * entered a position in to the location search box, has allowed the app to access their current position, or a default
 * position.
 * 
 * @param {Drug} drug - A drug object from the autocomplete dropdown
 */
function getPharmaciesForDrugAndPosition(selectedDrug) {
    const loaderId = 'getPharmaciesForDrugAndPosition';
    // Forces users out of street view
    State.map.getStreetView().setVisible(false);
    removePharmacies();
    if (!State.selectedDrug) {
        return false;
    };
    showLoader(loaderId);

    $.ajax({
        url: Config.endpoints.pharmacies,
        data: {
            lat: State.getLocationForSearch().lat,
            lng: State.getLocationForSearch().lng,
            din: selectedDrug.din,
            numberOfResults: Config.NUM_RESULTS
        }
    })
        .done(data => {
            State.pharmacies = data.map(pharmacy => new Pharmacy(pharmacy, selectedDrug, State.placesService));
            showPharmacies(State.pharmacies);
            hideLoader(loaderId);
        })
        .fail(err => {
            hideLoader(loaderId);
            console.warn(err)
        });
}

/**
 * Zooms the map in or out to fit the searched location and the current location
 * 
 * @param {array} markers - an array of Google Maps Marker objects
 * @returns {Map} A Google Maps Map object
 */
function zoomToFitLocations(markers) {
    var bounds = new google.maps.LatLngBounds(); 
    if (!_.isEmpty(markers)) {
        for (var i = 0; i < markers.length; i++) {
            if (markers[i]) {
                bounds.extend(markers[i].getPosition());
            } 
        }
        State.map.fitBounds(bounds);
        let newZoomLevel = State.map.getZoom();
        if (newZoomLevel > Config.MAX_ZOOM) {
            State.map.setZoom(Config.MAX_ZOOM);
        } else if (newZoomLevel < Config.MIN_ZOOM) {
            State.map.setZoom(Config.MIN_ZOOM);
        }
    };
    return State.map;
}

/**
 * Gets markers that are stored in the state
 * 
 * @param {string} locations - any number of arguments that are strings tied to a property stored in application state
 * @returns {array} markers - an array of Google Maps Marker objects
 */
function getMarkers(...locations) {
    var markers = locations.map(location => {
        let marker = State.getMarker(location);
        if (marker && marker !== 'undefined') {
            return State.getMarker(location);
        }
    });
    return markers;
}

/**
 * Renders search Pharmacy to the DOM. Takes the State.pharmacies object and iterates over it.
 */
function showPharmacies() {
    State.pharmacies.forEach(pharmacy => {
        pharmacy.createAndSetMarker(State.map);
        pharmacy.render('#cards');
    });
    if (!_.isEmpty(State.pharmacies)) {
        filterResults();
        $('#pharmacy-cards').addClass('show-cards');
        Carousel.setPositions(State.pharmacies.length, 330);
    } else {
        // Handles case where no providers are returned
        $('#pharmacy-cards').addClass('show-cards');
        $('#pharmacy-cards').append(`<div class="no-results-banner"><div class="title">${Utils.i18n('noResultsBannerTitle')}</div><div class="body">${Utils.i18n('noResultsBannerBody')}</div></div>`);
    };
}

/**
 * Centers the map to the closest preferred provider if the result is outside of the map's current view.
 * If there are no preferred providers, it will pan to the closest provider with data.
 */
function filterResults() {
    // Always have one result in the marker set
    let markers = [State.pharmacies[0].marker];
    let searchLocationMarker = State.getMarker('searchLocationMarker');

    // Add the anchor, either the search location or current location
    if (searchLocationMarker) {
        markers.push(searchLocationMarker);
    } else {
        markers.push(State.getMarker('currentLocationMarker'));
    }

    // Add any additional markers that may be in the catch radius
    _.forEach(State.pharmacies, pharmacy => {
        if (pharmacy.distance < Config.MAX_ZOOM_RADIUS) {
            markers.push(pharmacy.marker);
        }
    });

    zoomToFitLocations(markers);
}

/**
 * Removes pharmacy markers from the map, resets the State.pharmacies, removes all pharmcy cards, and resets the
 * carousel.
 */
function removePharmacies() {
    State.pharmacies.forEach(pharmacy => {
        pharmacy.removeMarker();
    });
    State.pharmacies = [];
    $('.no-results-banner').remove();
    $('.pharmacy-card').remove();
    Carousel.resetCarousel('#cards');
}

/**
 * Adds a marker to the map.
 * 
 * @param {object} position - A Google Maps latLng object, or an object literal with lat and lng as keys
 * @param {string} icon - Key for the icon to be used for the marker position. Resulting path must be to a .svg
 * @returns {Marker Object} A Google Maps Marker object
 */
function addMarkerToMap(position, icon) {
    return new google.maps.Marker({
        position: position,
        map: State.map,
        icon: Utils.generateGoogleMapIconForSvg(icon, 30, 30, 0, 0, 15, 15),
        optimized: false
    });
}



// WEBPACK FOOTER //
// ../D:/builds/ACES/Pharmacy Compass Production Support/PharmacyCompass2/Content/scripts/site.js